import { useMemo } from 'react';
const normaliseGroups = (groups) => {
    if (!Array.isArray(groups))
        return [];
    return groups
        .map((group) => {
        if (typeof group === 'string')
            return group;
        if (group && typeof group === 'object' && 'name' in group) {
            return group.name || null;
        }
        return null;
    })
        .filter((value) => Boolean(value));
};
const normaliseFlags = (flags) => {
    if (!flags || typeof flags !== 'object') {
        return {};
    }
    // Return empty object - add flag normalisation here as needed
    return {};
};
export const useHomeBootstrap = () => {
    return useMemo(() => {
        const cfn = window.CFN || {};
        const user = cfn.userId
            ? {
                id: cfn.userId,
                name: cfn.userName,
                email: cfn.userEmail
            }
            : null;
        return {
            user,
            groups: normaliseGroups(cfn.userGroups),
            flags: normaliseFlags(cfn.homeReactFlags)
        };
    }, []);
};
